import { QueryLevel } from "csi/view/_query/Level";
import declare from "dojo/_base/declare";
import AggregateFromBaseProductTableMixin from "./AggregateFromBaseProductTableMixin";

const FORMULATED_MATERIAL_SUBTYPE = "FormulatedMaterialSubtype";
const SUBTYPE = "Subtype";

const AggregateFromFormulatedMaterialTable = declare(AggregateFromBaseProductTableMixin, {

	/**
	 * @override
	 * Add filter for selected FormulatedMaterial Type
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		this.modifyQuery(FORMULATED_MATERIAL_SUBTYPE, SUBTYPE, ql);
	},
});

export = AggregateFromFormulatedMaterialTable;